import { useMutation, useQueryClient } from '@tanstack/react-query';
import { chatbotService } from '../../../services/ChatbotService';
import type {
  ChatbotMemberRole,
  ChatbotMembership,
} from '../../../types/chatbot';
import { chatbotQueryKeys } from '../chatbotQueryKeys';

export function useInviteChatbotMemberMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      chatbotId,
      userId,
      role,
    }: {
      chatbotId: string;
      userId: string;
      role: ChatbotMemberRole;
    }) => chatbotService.inviteMember(chatbotId, userId, role),
    onSuccess: (_result, variables) => {
      void queryClient.invalidateQueries({
        queryKey: chatbotQueryKeys.members(variables.chatbotId),
      });
    },
  });
}

export function useUpdateChatbotMemberRoleMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      chatbotId,
      member,
      role,
    }: {
      chatbotId: string;
      member: ChatbotMembership;
      role: ChatbotMemberRole;
    }) => chatbotService.updateMemberRole(chatbotId, member, role),
    onSuccess: (_result, variables) => {
      void queryClient.invalidateQueries({
        queryKey: chatbotQueryKeys.members(variables.chatbotId),
      });
    },
  });
}

export function useRemoveChatbotMemberMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      chatbotId,
      memberId,
    }: {
      chatbotId: string;
      memberId: string;
    }) => chatbotService.removeMember(chatbotId, memberId),
    onSuccess: (_result, variables) => {
      void queryClient.invalidateQueries({
        queryKey: chatbotQueryKeys.members(variables.chatbotId),
      });
      void queryClient.invalidateQueries({
        queryKey: chatbotQueryKeys.list(),
      });
    },
  });
}
